/*******************************************************************************
 * Copyright (c) 2019-2021 Singularity AI, Inc. - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 ******************************************************************************/
/* import */
import { combineReducers } from 'redux';
/* import all slices */
import { settingsReducer } from './settingsSlice';
import { settingsProfileReducer } from './settingsProfileSlice';
import { settingsPermissionReducer } from './settingsPermissionSlice';
import { worklistReducer } from './worklistSlice';
import { allcaseReducer } from './allcaseSlice';
import { teamInviteReducer } from './teamInviteSlice';
import { settingsDeviceReducer } from './settingsDeviceSlice';
import { setLanguageReducer } from "./language";
import { inComingReducer } from './incomingSlice';
import { outgoingReducer } from './outgoing';
import { managementReducer } from './management';
import { aiPlayGroundReducer } from './aiPlaygroundSlice';
import { animalResearchReducer } from './animalResearchSlice';
import { imagesReducer } from './images';
import { dataAnalusisReducer } from './dataAnalusis';
import { FindingReducer } from './finding';
import { ProjectReducer } from './project';
/*******************************************************************************
 * main
 ******************************************************************************/
export default combineReducers({
  worklist: worklistReducer,
  allcase: allcaseReducer,
  settings: settingsReducer,
  settingsProfile: settingsProfileReducer,
  settingsPermission: settingsPermissionReducer,
  teamInvite: teamInviteReducer,
  settingsDevice: settingsDeviceReducer,
  language: setLanguageReducer,
  inComing: inComingReducer,
  outgoing: outgoingReducer,
  memberManageMent: managementReducer,
  aiPlayGround: aiPlayGroundReducer,
  animalResearch: animalResearchReducer,
  images: imagesReducer,
  dataAnalusis: dataAnalusisReducer,
  finding: FindingReducer,
  project: ProjectReducer
});
